export const DEFAULT_PRESET_ID = "492856e0-fddd-4fed-9c60-2bd256115baf";
export const SIMPLE_PRESET_ID = "NsLinzJ9D9bk";
export const RAINBOW_PRESET_ID = "vBfA0B9nv0Zb";
export const PRESET_IN_APP_NAME = "template";

/**
 * Sentinel id for the synthetic "Base" card rendered first in the editor's
 * Templates panel. Decoupled from any DB row: the card is backed at runtime
 * by `localVideo.baseTemplateId` (resolved through `useEffectiveBaseTemplateId`).
 * Selecting Base writes `style_preset_id = null` on the video, NOT this id.
 */
export const BASE_CARD_ID = "__base__";
